/**
 * Users
 */

// React
import React, {FunctionComponent, useEffect, useState} from 'react';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {getReportsCenterOrdersAction} from './actions';
import {Store} from '../../redux/reducers';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectReportCenterOrderslist,
} from './selectors';

// Components

import RenderFilter from '../../utils/listDaynamicFilter';
import ListCenterOrders from './componets/listCenterOrders';
import CSVCenterOrders from './componets/csvCenterOrders';

// UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Typography,
  Paper,
  CircularProgress,
  Grid,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Button,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {mdiArrowRight, mdiChevronDown} from '@mdi/js';

// Helper
import {removeEmptyValueObject} from '../../utils/helpers';

// Type
import {PropsCenterOrders, SelectorPropsCenterOrders} from './interfaces';
import type {Filter} from '../../utils/listDaynamicFilter';

// StyleExpansionPanel
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    title: {
      '@media (max-width: 768px)': {
        fontSize: '16px',
        fontWeight: 500,
      },
    },
    subtitle: {
      fontWeight: 500,
      fontSize: '30px',

      '@media (max-width: 768px)': {
        fontSize: '20px',
      },
    },
  })
);

const CenterOrders: FunctionComponent<PropsCenterOrders> = (
  props: PropsCenterOrders
) => {
  const [filters, setFilters] = useState([] as Filter[]);
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);

  useEffect(() => {
    getReportsCenterOrders();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps
  const classes = useStyles();

  const getReportsCenterOrders = () => {
    const {page, size} = filtersValues;
    const {centerId} = props.match.params;

    props.reportCenterOrdersDispatch({
      centerId: Number(centerId),
      ...removeEmptyValueObject(filtersValues),
      page,
      size,
    });
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'date-picker',
        id: 'from',
        label: 'تاریخ تحویل از ',
      },
      {
        type: 'date-picker',
        id: 'to',
        label: '  تا تاریخ تحویل ',
      },
    ]);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h4" component="h2" className={classes.title}>
            {`سفارش‌های مرکز`}
          </Typography>
          <div className={classes.subtitle}>
            {new URLSearchParams(props.history.location.search).get(
              'centerName'
            )}
          </div>

          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </Grid>

        <Grid
          container
          item
          xs={12}
          md={6}
          direction="row-reverse"
          alignItems="center"
        >
          <CSVCenterOrders
            // ordersDispatch={props.allOrdersDispatch}
            data={props.reportCenterOrdersList}
            filtersValues={filtersValues}
            loading={props.loading}
          />
        </Grid>

        <Grid xs={12} item>
          <ExpansionPanel>
            <ExpansionPanelSummary
              expandIcon={<Icon path={mdiChevronDown} size={1} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              فیلترها
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{display: 'block'}}>
              <RenderFilter
                filters={filters}
                onFilter={(filtervalues: any) => {
                  setFiltersValues({
                    ...filtervalues,
                    page: 0,
                    size: 10,
                  });
                }}
              />
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </Grid>
        <Grid item xs={12}>
          {/* <div>{`تعداد:${props.count}`}</div> */}
          <Paper>
            {props.loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              <>
                <ListCenterOrders data={props.reportCenterOrdersList} />
              </>
            )}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<
  Store,
  SelectorPropsCenterOrders
>({
  reportCenterOrdersList: makeSelectReportCenterOrderslist(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    reportCenterOrdersDispatch: (payload: Object) =>
      dispatch(getReportsCenterOrdersAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(CenterOrders);
